module.exports = __webpack_public_path__ + "img/group_gui.5104b3ea.png";